const initAppointmentsCalendar = () => {
  const calendarEl = document.querySelector('[data-appointments-calendar="true"]')
  if (!calendarEl || typeof window.FullCalendar === 'undefined') {
    return
  }

  const eventsUrl = calendarEl.dataset.eventsUrl
  const newUrl = calendarEl.dataset.newUrl
  const showUrl = calendarEl.dataset.showUrl
  const canBook = calendarEl.dataset.canBook === 'true'
  const initialView = calendarEl.dataset.initialView || 'timeGridWeek'

  const calendar = new window.FullCalendar.Calendar(calendarEl, {
    initialView: initialView,
    timeZone: 'local',
    locale: 'es',
    height: 'auto',
    headerToolbar: {
      left: 'prev,next today',
      center: 'title',
      right: 'dayGridMonth,timeGridWeek,listWeek'
    },
    buttonText: {
      today: 'Hoy',
      month: 'Mes',
      week: 'Semana',
      list: 'Lista'
    },
    eventTimeFormat: {
      hour: '2-digit',
      minute: '2-digit',
      hour12: false
    },
    events: (fetchInfo, successCallback, failureCallback) => {
      try {
        const url = new URL(eventsUrl, window.location.origin)
        url.searchParams.set('start', fetchInfo.startStr)
        url.searchParams.set('end', fetchInfo.endStr)

        fetch(url, { headers: { Accept: 'application/json' } })
          .then((response) => {
            if (!response.ok) throw new Error('Network response was not ok')
            return response.json()
          })
          .then((data) => successCallback(data))
          .catch((error) => {
            console.error('Error loading appointments:', error)
            failureCallback(error)
          })
      } catch (error) {
        console.error('Invalid events URL', error)
        failureCallback(error)
      }
    },
    eventClassNames: (arg) => {
      const status = arg.event.extendedProps.status || 'available'
      return [`appointments-event--${status}`]
    },
    eventClick: (info) => {
      const status = info.event.extendedProps.status
      const slotId = info.event.id

      if (status === 'available' || status === 'cancelled') {
        if (canBook) {
          window.location.href = `${newUrl}?time_slot_id=${slotId}`
          return
        }

        window.location.href = `${showUrl}/${slotId}`
        return
      }

      window.location.href = `${showUrl}/${slotId}`
    }
  })

  calendar.render()
}

const initQuickBookingModal = () => {
  const button = document.getElementById('continue-to-booking')
  if (!button) return

  button.addEventListener('click', () => {
    const selector = document.getElementById('available-slot-selector')
    if (!selector || !selector.value) return
    const url = new URL('/appointments/new', window.location.origin)
    url.searchParams.set('time_slot_id', selector.value)
    window.location.href = url.toString()
  })
}

document.addEventListener('DOMContentLoaded', () => {
  initAppointmentsCalendar()
  initQuickBookingModal()
})
